import { render, staticRenderFns } from "./ListDevolveHistories.vue?vue&type=template&id=1664e823&scoped=true&"
import script from "./ListDevolveHistories.vue?vue&type=script&lang=ts&"
export * from "./ListDevolveHistories.vue?vue&type=script&lang=ts&"
import style0 from "./ListDevolveHistories.vue?vue&type=style&index=0&id=1664e823&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1664e823",
  null
  
)

export default component.exports